<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <label class="form-label">Бюджет</label>
        <div class="d-flex align-items-center gap-2">
          <input
              v-model="fields.budget"
              type="number"
              class="form-control"
              placeholder="Бюджет"
              @change="onChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineOptions, reactive, watch} from "vue"

defineOptions({
  name: "WishlistBudget"
})

const props = defineProps({
  payload: {
    type: Object,
    default: () => ({}),
  },
})

const emit = defineEmits(["onChange"])

const fields = reactive({
  budget: null,
})

watch(() => props.payload, (newPayload) => {
  if (newPayload) {
    fields.budget = newPayload.budget
  }
}, {immediate: true})

function onChange(e) {
  emit("onChange", e.target.value)
}
</script>

<style scoped src="./style.css"></style>
